import { Button, type ButtonProps, CircularProgress } from '@mui/material'
import React from 'react'

type LoadingButtonProps = Omit<ButtonProps, 'disabled' | 'startIcon'> & {
  isDisabled?: boolean
  isLoading: boolean
}

function ButtonLoadingIcon() {
  return <CircularProgress size={16} sx={{ color: 'inherit' }} />
}

export const LoadingButton: React.FC<LoadingButtonProps> = ({
  children,
  isDisabled,
  isLoading,
  variant = 'contained',
  onClick,
  ...rest
}) => {
  return (
    <Button
      {...rest}
      disabled={isDisabled}
      startIcon={isLoading ? <ButtonLoadingIcon /> : null}
      variant={variant}
      onClick={onClick}
    >
      {children}
    </Button>
  )
}
